<span>
	<span style="font-size: 24px ; font-family: digital-7, sans-serif;">{{ jumboText }}</span>
</span>